// app/javascript/projects/components/ProjectNotFound.jsx

import React from 'react';
import FullPageMessage from './FullPageMessage';
import { useProjectModal } from '../../contexts/ProjectModalContext';

function ProjectNotFound() {
  const { showProjectModal } = useProjectModal();
  
  return (
    <FullPageMessage
      header='Project not Found'
      body='You do not have access to this project or it does not exist.'
      onClick={showProjectModal}
      buttonText='See Your Projects'
    />
  );
}

export default ProjectNotFound;